<div class="signature-canvas-wrapper">
  <canvas (pointerup)="signatureTouched()" #signatureCanvas id="signature-canvas"></canvas>
  <p class="tip">{{ 'signature.tipText' | translate }}</p>
</div>
